import { useSyncExternalStore } from 'react';

// Tailwind's `sm` breakpoint
const SMALL_SCREEN_QUERY = '(max-width: 639px)';

const subscribe = (onChange: () => void) => {
  const mediaQuery = window.matchMedia(SMALL_SCREEN_QUERY);
  mediaQuery.addEventListener('change', onChange);
  return () => mediaQuery.removeEventListener('change', onChange);
};

const getSnapshot = () => window.matchMedia(SMALL_SCREEN_QUERY).matches;

/** `true` below Tailwind's `sm` breakpoint (640px). */
export const useIsSmallScreen = () =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
